// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"3c588029","259":"26ebd5ca","303":"84d7bed2","522":"0b0cc644","549":"3febbd95","702":"5b79fe5f","897":"cf51ea54","906":"c2093aeb","957":"64552564"}[chunkId] + ".chunk.js";
};